import React, { useState } from "react";
import { Button, Tooltip, Modal, Form, message, Input } from "antd";
import { EditOutlined } from "@ant-design/icons";
import activitiesService from "../../services/activitiesService";
import useAuth from "../../hooks/useAuth";

export default function BotonEditarComentario({
  item,
  textactual = "",
  consultaActividades,
  eventId,
  activityId,
}) {
  const { session } = useAuth();
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    const { comment } = values;
    editarComentario(comment);
  };

  const editarComentario = async (comment) => {
    setLoading(true);
    try {
      // Crear el registro con el formato JSON simple esperado por editarComentario
      const registro = {
        comment: comment,
      };

      // Llamar a la función editarComentario del servicio
      await activitiesService.editarComentario(
        registro,
        session?.idToken || "",
        eventId || item?.eventId,
        activityId || item?.protocol_activity_subactivity
      );

      message.success("Comentario editado correctamente");
      consultaActividades();
      setOpen(false);
      form.resetFields();
    } catch (error) {
      console.error("Error al editar comentario:", error);
      message.error("No se pudo editar el comentario. Inténtalo nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  const validateMessages = {
    required: "Es requerido",
    types: {
      email: "Correo no válido",
      number: "Número no válido",
    },
  };

  return (
    <>
      <Tooltip title="Editar Comentario (Nuevo método)">
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => {
            setOpen(true);
            form.setFieldsValue({ comment: textactual });
          }}
        />
      </Tooltip>

      <Modal
        title="Editar Comentario"
        open={open}
        onCancel={() => {
          setOpen(false);
          form.resetFields();
        }}
        footer={null}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          name="editar-comentario"
          onFinish={onFinish}
          style={{
            maxWidth: 600,
          }}
          validateMessages={validateMessages}
        >
          <Form.Item
            name="comment"
            label="Comentario"
            rules={[
              {
                required: true,
                message: "Debes completar este campo.",
              },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Escribe tu comentario aquí..."
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
            <Button
              style={{ marginRight: 8 }}
              onClick={() => {
                setOpen(false);
                form.resetFields();
              }}
            >
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Guardar
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
